import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';

/**
 * Cookie-based AuthInterceptor (CW-13d-client §3.3).
 *
 * Sets the `withCredentials` XHR flag on every request targeting the
 * backend API so the browser includes the HttpOnly `tb_access` /
 * `tb_refresh` cookies. Non-API requests (static assets, third-party
 * URLs) pass through untouched.
 *
 * The previous implementation read a token from `AuthService.getToken()`
 * and added a bearer header. That pattern is removed:
 *   - Tokens no longer live in browser storage
 *   - `withCredentials: true` is a property of `HttpRequest`, set via
 *     `req.clone({ withCredentials: true })` — NOT a header value
 *
 * Previous live bug: `setHeaders: { withCredentials: 'true' }` added
 * the string "true" as a request HEADER rather than enabling cookie
 * credentialing. Cookies were not actually being sent.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }
  return next(req.clone({ withCredentials: true }));
};
